function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  appearance: none;\n  padding: 0;\n  border: none;\n  background: none;\n  &:focus {\n    ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { getFocusStyles } from '@doordash/design-language';
import styled from 'styled-components';
export var PasswordToggle = styled.button.attrs({
  type: 'button'
})(_templateObject(), getFocusStyles());